module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10026.5a778734.jpg";